import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_OFFER_PREVIEWS_BY_SCHOOL = gql`
  query RookieOfferPreviewsBySchool($districtId: Int!, $schoolId: Int!) {
    rookieOfferPreviewsBySchool(districtId: $districtId, schoolId: $schoolId) {
      id
      shortCode
      remainingSlots
      provider {
        id
        uuid
        name
        locations {
          id
          name
          address {
            street
            number
            addressCity {
              id
              name
            }
          }
        }
        companyProfilePicture {
          id
          name
          image {
            ...imageFields
          }
        }
      }
      timeSlot {
        id
        openAt
        closeAt
        workFrom
        workTo
      }
      job {
        id
        bicID
        name
        interestFields {
          id
          interestName
          subHeading
        }
      }
    }
  }
  ${ImageFragment}
`;
